module.exports = __webpack_public_path__ + "static/scale-model-of-goodwood-museum-&-gardens-in-tallahassee-florida-aee348eb4e55e5c77fda2ae3abd54b05.png";